@if (symbol()) {
  @if (deviceService.isMobile() && isEditDetailsModalOpen) {
    <!-- Mobile: Edit Asset Details as full page -->
    <div class="tw-flex tw-flex-col tw-min-h-full tw-bg-color-surface-page">
      <modal-header
        [title]="'editSymbolDetails' | i18n"
        [showBackButton]="true"
        [showCloseButton]="false"
        (onBackClicked)="closeEditDetailsModal()"
      ></modal-header>
      <div class="tw-flex tw-flex-col tw-gap-4 tw-p-4">
        <app-edit-symbol-form
          #detailsFormElMobile
          [(symbol)]="symbol"
          [formMode]="'details'"
          (symbolUpdated)="onSymbolUpdated($event)"
        ></app-edit-symbol-form>
        <div class="tw-flex tw-w-full tw-gap-3 tw-pt-2">
          <button
            type="button"
            class="tw-rounded-full tw-w-full tw-shadow-elevation-card tw-bg-dt-surface-card tw-px-6 tw-py-2.5 tw-text-sm tw-font-medium tw-text-color-text-secondary hover:tw-bg-dt-surface-elevated tw-cursor-pointer"
            (click)="closeEditDetailsModal()"
          >
            {{ "cancel" | i18n }}
          </button>
          <button
            type="button"
            class="tw-rounded-full tw-w-full tw-bg-dt-custom-teal-11 tw-shadow-elevation-cta-glow tw-px-8 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-90 tw-border-none tw-cursor-pointer"
            (click)="saveDetailsAndClose(detailsFormElMobile)"
          >
            {{ "save" | i18n }}
          </button>
        </div>
      </div>
    </div>
  } @else if (deviceService.isMobile() && isAddPriceModalOpen) {
    <!-- Mobile: Update Asset Price as full page -->
    <div class="tw-flex tw-flex-col tw-min-h-full tw-bg-color-surface-page">
      <modal-header
        [title]="'updateSymbolPrice' | i18n"
        [showBackButton]="true"
        [showCloseButton]="false"
        (onBackClicked)="closeAddPriceModal()"
      ></modal-header>
      <div class="tw-flex tw-flex-col tw-gap-4 tw-p-4">
        <app-edit-symbol-form
          #priceFormElMobile
          [(symbol)]="symbol"
          [formMode]="'addPrice'"
          (symbolUpdated)="onSymbolUpdated($event)"
        ></app-edit-symbol-form>
        <button
          type="button"
          class="tw-w-full tw-rounded-full tw-bg-dt-custom-teal-11 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-opacity-90 tw-shadow-elevation-cta-glow tw-border-none tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
          [disabled]="
            !(
              (!priceFormElMobile.getIsFreeSubscription() && priceFormElMobile.isFindPrice()) ||
              (!isReadOnlySymbol() && !priceFormElMobile.isFindPrice())
            )
          "
          (click)="addPriceAndClose(priceFormElMobile)"
        >
          {{ "save" | i18n }}
        </button>
      </div>
    </div>
  } @else {
    <!-- Normal details view (desktop always; mobile when no sub-page open) -->
    <app-details-wrapper
      [title]="displayCode()"
      [headerIconName]="displayIcon()"
      [headerIconSize]="5"
      [showDesktopHeader]="false"
      [isOverlay]="isOverlay"
      (onBackClicked)="handleBackClick()"
      [showEditIcon]="!isReadOnlySymbol()"
      (onEditClicked)="openEditDetailsModal()"
    >
      @if (!showMobileLayout) {
        <div class="tw-mb-4 tw-flex tw-items-center tw-gap-3.5">
          <div
            class="tw-flex tw-h-11 tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-color-surface-card tw-shadow-elevation-card tw-text-dt-success-500"
          >
            <icon [name]="displayIcon()" [size]="5"></icon>
          </div>
          <div class="tw-min-w-0 tw-flex-1">
            <div class="tw-text-lg tw-font-semibold tw-text-color-text-default">
              {{ displayCode() }}
            </div>
          </div>
          @if (!isReadOnlySymbol()) {
            <button
              type="button"
              (click)="openEditDetailsModal()"
              aria-label="Edit asset"
              class="tw-flex tw-h-11 tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-color-surface-card tw-shadow-elevation-card tw-text-dt-success-500"
            >
              <icon name="writing" [size]="5"></icon>
            </button>
          }
        </div>
      }
      <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-pl-1 tw-pt-1 tw-mb-4">
        <div class="tw-rounded-xl tw-p-4 tw-shadow-elevation-card tw-bg-dt-surface-card">
          <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
            <span
              class="tw-text-xs tw-font-bold tw-tracking-wider tw-text-color-text-tertiary tw-uppercase"
            >
              {{ "latestPrice" | i18n }}
            </span>
            @if (!isReadOnlySymbol()) {
              <button
                type="button"
                class="tw-rounded-lg tw-bg-dt-surface-card tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-color-text-secondary tw-shadow-elevation-card hover:tw-bg-dt-surface-elevated tw-cursor-pointer"
                (click)="openAddPriceModal()"
              >
                {{ "addPrice" | i18n }}
              </button>
            }
          </div>

          <div class="tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3 tw-items-start tw-py-2">
            <div class="tw-flex tw-flex-col tw-gap-2 tw-min-w-0 tw-flex-auto">
              <div class="tw-flex tw-items-baseline tw-gap-2 tw-flex-wrap">
                <span
                  class="tw-text-4xl tw-font-semibold tw-tracking-tight tw-text-color-text-default tw-break-words"
                >
                  {{ symbol()?.c_asOf?.rate | number: "1.0-2" }}
                </span>
                <span class="tw-text-sm tw-font-medium tw-text-color-text-tertiary tw-uppercase">
                  {{ symbol()?.c_asOf?.symbol || "USD" }}
                </span>
              </div>
              <div>
                <span
                  [class]="
                    'tw-inline-flex tw-items-center tw-rounded-md tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium ' +
                    getBadgeClass(symbol()?.c_asOf?.source)
                  "
                >
                  {{ getSourceLabel(symbol()?.c_asOf?.source) }}
                </span>
              </div>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0 tw-flex-auto">
              <span
                class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
              >
                {{ "asOnDate" | i18n }}
              </span>
              <div class="tw-text-sm tw-font-medium tw-text-color-text-default">
                {{ symbol()?.c_asOf?.date?.date | date: "yyyy-MM-dd" }}
                @if (symbol()?.c_asOf?.date?.date) {
                  <span class="tw-text-color-text-tertiary tw-font-normal tw-ml-1">
                    ({{ getRelativeTime(symbol()?.c_asOf?.date?.date) }})
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-pl-1 tw-pt-1">
        <app-widget [title]="'priceHistory' | i18n" [iconName]="'time'">
          @if (showStartPicker() || showEndPicker()) {
            <div
              class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-50 tw-z-10"
              (click)="togglePickersVisibility(PICKER_TYPE.BOTH)"
            ></div>
          }

          <div
            class="tw-w-full tw-h-12 tb:tw-h-auto tw-flex tb:tw-flex-col tw-gap-2 tw-items-center tb:tw-items-stretch tw-mb-4"
            [appScrollLock]="isPickerOpen"
          >
            <div
              class="tw-w-full tw-min-w-0 tw-h-12 tw-relative tw-z-20 tw-bg-color-surface-input left-round-border tb:tw-rounded-t-2xl tb:tw-rounded-b-lg"
            >
              <div
                #startPickerTrigger
                class="tw-w-full tw-h-full left-round-border tb:tw-rounded-t-2xl tb:tw-rounded-b-lg tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-6 xl:tw-px-3 tw-shadow-modal-strong hover:tw-bg-color-surface-hover tw-cursor-pointer border-gradient-neuomorphic hover-border-past"
                [ngClass]="{
                  'tw-bg-color-surface-elevated border-active-past !tw-shadow-none':
                    showStartPicker(),
                }"
                (click)="togglePickersVisibility(PICKER_TYPE.START)"
              >
                <div
                  class="tw-w-full tw-min-w-0 tw-flex tw-items-center tw-justify-between tw-gap-2"
                >
                  <div
                    class="tw-flex tw-gap-2 xl:tw-flex-col xl:tw-gap-0 tw-min-w-0 tw-overflow-hidden"
                  >
                    <span>{{ "startDate" | i18n }}</span>
                    <span>{{ displayDateText().startDate }}</span>
                  </div>
                  <icon name="calendar" [size]="6" [currentColor]="'dt-text-secondary'"></icon>
                </div>
              </div>
              @if (showStartPicker()) {
                <app-calendar
                  #startCalendar
                  [pickerType]="'start'"
                  [dateRange]="dateRange()"
                  [originalDateRange]="originalDateRange()"
                  [timeDirectionOptions]="[AGO]"
                  [currentDateFilter]="startDateFilter()"
                  (dateChangeEvent)="onDateChange($event)"
                  (confirmEvent)="onStartPickerConfirm()"
                  (cancelEvent)="onPickerCancel()"
                  class="past"
                  [ngStyle]="startPickerStyle()"
                ></app-calendar>
              }
            </div>

            <div
              class="tw-w-full tw-min-w-0 tw-h-12 tw-relative tw-z-20 tw-bg-color-surface-input right-round-border tb:tw-rounded-t-lg tb:tw-rounded-b-2xl"
            >
              <div
                #endPickerTrigger
                class="tw-w-full tw-h-full right-round-border tb:tw-rounded-t-lg tb:tw-rounded-b-2xl tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-6 xl:tw-px-3 tw-shadow-modal-strong hover:tw-bg-color-surface-hover tw-cursor-pointer border-gradient-neuomorphic hover-border-past"
                [ngClass]="{
                  'tw-bg-color-surface-elevated border-active-past !tw-shadow-none':
                    showEndPicker(),
                }"
                (click)="togglePickersVisibility(PICKER_TYPE.END)"
              >
                <div
                  class="tw-w-full tw-min-w-0 tw-flex tw-items-center tw-justify-between tw-gap-2"
                >
                  <div
                    class="tw-flex tw-gap-2 xl:tw-flex-col xl:tw-gap-0 tw-min-w-0 tw-overflow-hidden"
                  >
                    <span>{{ "endDate" | i18n }}</span>
                    <span>{{ displayDateText().endDate }}</span>
                  </div>
                  <icon name="calendar" [size]="6" [currentColor]="'dt-text-secondary'"></icon>
                </div>
              </div>
              @if (showEndPicker()) {
                <app-calendar
                  #endCalendar
                  [pickerType]="'end'"
                  [dateRange]="dateRange()"
                  [originalDateRange]="originalDateRange()"
                  [timeDirectionOptions]="[AGO]"
                  [currentDateFilter]="endDateFilter()"
                  (dateChangeEvent)="onDateChange($event)"
                  (confirmEvent)="onEndPickerConfirm()"
                  (cancelEvent)="onPickerCancel()"
                  class="past"
                  [ngStyle]="endPickerStyle()"
                ></app-calendar>
              }
            </div>
          </div>

          <div
            appGlossScroll
            class="tw-flex tw-flex-col tw-gap-2 tw-max-h-80 tw-overflow-y-auto tw-overscroll-contain tw-pr-3"
          >
            @for (item of filteredHistory(); track getId(item)) {
              <div
                class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2 tw-rounded-lg tw-p-4 tw-shadow-elevation-card tw-cursor-pointer hover:tw-bg-dt-surface-sunken tw-transition-colors"
                (click)="showPriceDetails(item)"
              >
                <div class="tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0 tw-flex-1">
                  <span class="tw-font-semibold tw-text-color-text-default">
                    {{ item.rate | number: "1.2-2" }} {{ item.symbol }}
                  </span>
                  @if (item.source) {
                    <span
                      [class]="
                        'tw-w-fit tw-rounded-md tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium ' +
                        getBadgeClass(item.source)
                      "
                    >
                      {{ getSourceLabel(item.source) }}
                    </span>
                  }
                </div>
                <div class="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
                  <span class="tw-text-sm tw-text-color-text-tertiary">
                    {{ item.date.date | date: "yyyy-MM-dd" }}
                  </span>
                  <div class="tw-text-color-text-tertiary">
                    <icon [name]="'right-arrow'" [size]="5"></icon>
                  </div>
                </div>
              </div>
            }
          </div>
        </app-widget>
      </div>

      <div class="tw-px-3 tw-py-4">
        <button
          type="button"
          class="tw-text-sm tw-font-medium tw-text-dt-text-error hover:tw-opacity-80 tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
          (click)="deleteSymbol()"
        >
          {{ "deleteSymbol" | i18n }}
        </button>
      </div>
    </app-details-wrapper>
  }
}

<!-- Desktop-only modals -->
@if (!deviceService.isMobile()) {
  @if (isEditDetailsModalOpen) {
    <div class="tw-fixed tw-inset-0 tw-z-50 tw-bg-neutral-900/40 tw-backdrop-blur-sm">
      <div
        appModalOverlay
        [appModalOverlayLabel]="'editSymbolDetails' | i18n"
        (modalOverlayDismiss)="closeEditDetailsModal()"
        class="tw-fixed tw-top-0 tw-right-0 tw-h-full tw-w-[560px] tw-max-w-full tw-bg-dt-surface-card tw-shadow-2xl tw-flex tw-flex-col tw-rounded-l-2xl tw-overflow-hidden symbol-right-panel"
        [class.is-closing]="isEditDetailsClosing"
        (animationend)="onEditDetailsPanelAnimationEnd($event)"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-px-8 tw-h-[70px] tw-shrink-0">
          <h3 class="tw-text-xl tw-font-medium tw-text-color-text-default">
            {{ "editSymbolDetails" | i18n }}
          </h3>
          <button type="button" class="btn-icon" (click)="closeEditDetailsModal()">
            <icon [name]="'close'" [size]="5"></icon>
          </button>
        </div>

        <div
          appGlossScroll
          class="tw-flex-1 tw-overflow-y-auto tw-bg-dt-surface-card tw-px-8 tw-py-6"
        >
          <app-edit-symbol-form
            #detailsFormEl
            [(symbol)]="symbol"
            [formMode]="'details'"
            (symbolUpdated)="onSymbolUpdated($event)"
          ></app-edit-symbol-form>
        </div>

        <div class="tw-shrink-0 tw-bg-dt-surface-card tw-px-8 tw-pb-6 tw-flex tw-gap-3">
          <button
            type="button"
            class="tw-rounded-full tw-flex-1 tw-shadow-elevation-card tw-bg-dt-surface-card tw-px-6 tw-py-3 tw-text-sm tw-font-medium tw-text-color-text-secondary hover:tw-bg-dt-surface-elevated tw-cursor-pointer"
            (click)="closeEditDetailsModal()"
          >
            {{ "cancel" | i18n }}
          </button>
          <button
            type="button"
            class="tw-rounded-full tw-flex-1 tw-bg-dt-surface-on-action tw-px-6 tw-py-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-90 tw-shadow-elevation-cta-glow tw-border-none tw-cursor-pointer"
            (click)="saveDetailsAndClose(detailsFormEl)"
          >
            {{ "save" | i18n }}
          </button>
        </div>
      </div>
    </div>
  }

  @if (isAddPriceModalOpen) {
    <div class="tw-fixed tw-inset-0 tw-z-50 tw-bg-neutral-900/40 tw-backdrop-blur-sm">
      <div
        appModalOverlay
        [appModalOverlayLabel]="'updateSymbolPrice' | i18n"
        (modalOverlayDismiss)="closeAddPriceModal()"
        class="tw-fixed tw-top-0 tw-right-0 tw-h-full tw-w-[560px] tw-max-w-full tw-bg-dt-surface-card tw-shadow-2xl tw-flex tw-flex-col tw-rounded-l-2xl tw-overflow-hidden symbol-right-panel"
        [class.is-closing]="isAddPriceClosing"
        (animationend)="onAddPricePanelAnimationEnd($event)"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-px-8 tw-h-[70px] tw-shrink-0">
          <h3 class="tw-text-xl tw-font-medium tw-text-color-text-default">
            {{ "updateSymbolPrice" | i18n }}
          </h3>
          <button type="button" class="btn-icon" (click)="closeAddPriceModal()">
            <icon [name]="'close'" [size]="5"></icon>
          </button>
        </div>

        <div
          appGlossScroll
          class="tw-flex-1 tw-overflow-y-auto tw-bg-dt-surface-card tw-px-8 tw-py-6"
        >
          <app-edit-symbol-form
            #priceFormEl
            [(symbol)]="symbol"
            [formMode]="'addPrice'"
            (symbolUpdated)="onSymbolUpdated($event)"
          ></app-edit-symbol-form>
        </div>

        <div class="tw-shrink-0 tw-bg-dt-surface-card tw-px-8 tw-pb-6">
          <button
            type="button"
            class="tw-w-full tw-rounded-full tw-bg-dt-custom-teal-11 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-opacity-90 tw-shadow-elevation-cta-glow tw-border-none tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            [disabled]="
              !(
                (!priceFormEl.getIsFreeSubscription() && priceFormEl.isFindPrice()) ||
                (!isReadOnlySymbol() && !priceFormEl.isFindPrice())
              )
            "
            (click)="addPriceAndClose(priceFormEl)"
          >
            {{ "save" | i18n }}
          </button>
        </div>
      </div>
    </div>
  }
}
